<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'DistributorOrderList' }">
          已办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>详细信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info :document-i-d="documentID" @initedBaseInfo="initedBaseInfo" />
    <subject-product :document-i-d="documentID" :base-info="baseInfo" />
    <div>
      <el-button type="primary" @click="goBack">
        返回
      </el-button>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from '../handlePrice/baseInfo';
import SubjectProduct from './SubjectProduct';
export default {
  data () {
    return {
      tabsActive: '1',
      baseInfo: {}
    };
  },
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  components: {
    baseInfo,
    SubjectProduct
  },
  computed: {},
  methods: {
    initedBaseInfo (val) {
      this.baseInfo = val;
    },
    goBack () {
      this.$router.go(-1);
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss"></style>
